import { solutionURL } from '../endpoints';
import PromiseCache from '../utils/promise-cache';
import FetchWithAuth from '../utils/fetch-with-auth';
function SolutionService(authState) {
  const fetch = new FetchWithAuth(authState);
  const cache = new PromiseCache(authState);
  async function listSolutions() {
    return await cache('listSolutions', async () => {
      const res = await fetch(`${solutionURL}/solutions`, {
        headers: {
          'content-type': 'application/json'
        }
      });
      const json = await res.json();
      return json;
    })();
  }
  const getSolution = async solutionId => {
    const {
      solutions
    } = await listSolutions();
    if (Array.isArray(solutions)) {
      if (solutionId) {
        return solutions.find(s => s.id === solutionId);
      }
      // if no solutionId was passed in, return the first solution
      return solutions[0];
    }
  };
  return {
    listSolutions,
    getSolution
  };
}
export default SolutionService;
//# sourceMappingURL=solution.js.map